import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

export interface CTMCampaign {
  id: string
  name: string
  ref: string
  welcomeMessage: string
  link: string
  clicks: number
  lastClick: number | null
  createdAt: number
}

export interface IceBreaker {
  question: string
  payload: string
}

export interface MessengerProfile {
  greeting?: { locale: string; text: string }[]
  get_started?: { payload: string }
  ice_breakers?: { call_to_actions: { question: string; payload: string }[]; locale: string }[]
}

export function useCTMCampaigns(pageId: string | null) {
  return useQuery<CTMCampaign[]>({
    queryKey: ['ctm', pageId],
    queryFn: () => api.get(`/ctm/${pageId}`),
    enabled: !!pageId,
  })
}

export function useCreateCTM(pageId: string | null) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: { name: string; ref: string; welcomeMessage?: string }) =>
      api.post<CTMCampaign>(`/ctm/${pageId}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ctm', pageId] }),
  })
}

export function useDeleteCTM(pageId: string | null) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (campaignId: string) =>
      api.delete(`/ctm/${pageId}/${campaignId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ctm', pageId] }),
  })
}

export function useMessengerProfile(pageId: string | null) {
  return useQuery<MessengerProfile>({
    queryKey: ['ctm-profile', pageId],
    queryFn: () => api.get(`/ctm/${pageId}/profile`),
    enabled: !!pageId,
  })
}

export function useSaveMessengerProfile(pageId: string | null) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: { greeting?: string; getStartedPayload?: string; iceBreakers?: IceBreaker[] }) =>
      api.post(`/ctm/${pageId}/profile`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ctm-profile', pageId] }),
  })
}
